import {gql} from 'apollo-angular';
import {StatusFragment} from "./fragments/Status";

export const GET_GAME_TIMER = gql`
  query GetGameTimer($schoolClassId: Int!) {
    getGameTimer(schoolClassID: $schoolClassId) {
      id
      schoolClassID
      startAt
      endAt
      duration
      createdAt
      status {
        ...statusFields
      }
    }

  }
  ${StatusFragment}
`;
